"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toDollarAmount = toDollarAmount;
exports.toHourAndMinuteDisplay = toHourAndMinuteDisplay;
/**
 * @param valInMinorUnits Pennies
 * @param hideFractionOnWholeDollar Only display pennies if necessary (500 = $5, 510 = $5.10)
 * @returns Formatted string with dollar sign
 */
function toDollarAmount(valInMinorUnits, hideFractionOnWholeDollar = true, prefix = '$') {
    const valInUsd = valInMinorUnits / 100;
    const minimumFractionDigits = hideFractionOnWholeDollar
        ? valInUsd % 1 === 0
            ? 0
            : 2
        : 2;
    return `${prefix}${valInUsd.toLocaleString('US', {
        currency: 'USD',
        minimumFractionDigits,
        maximumFractionDigits: 2,
    })}`;
}
function toHourAndMinuteDisplay(minutes, shortHand = true, hideZeroMinutes = true) {
    const sign = minutes < 0 ? '-' : '';
    const abs = Math.abs(minutes);
    const hours = Math.floor(abs / 60);
    const mins = abs % 60;
    if (shortHand) {
        if (hideZeroMinutes && mins === 0) {
            return `${sign}${hours}h`;
        }
        return `${sign}${hours}h ${mins}m`;
    }
    return `${sign}${hours} hour${hours === 1 ? '' : 's'}, ${mins} minute${mins === 1 ? '' : 's'}`;
}
//# sourceMappingURL=formatters.js.map